import { FocusIcon } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogOverlay,
  DialogTitle,
} from '../../ui/dialog';
import { ScrollArea } from '@/components/ui/scroll-area';
import React, { useState } from 'react';
import { Media } from '@/src/models/MeidaDto';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

interface ImageItem {
  media: Media;
}

export interface MultipleImagePreviewProps {
  images: ImageItem[];
  width?: number;
  height?: number;
  previewWidth?: number;
  isPreviewRatioFixed?: boolean;
}

export default function MultipleImagePreview({
  images,
  width = 100,
  height = 100,
  previewWidth = 700,
  isPreviewRatioFixed = true,
}: MultipleImagePreviewProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedIndex, setSelectedIdx] = useState<number | null>(null);

  return (
    <>
      <ul className="flex flex-wrap gap-2">
        {images.map((item, idx) => (
          <li key={idx.toString()}>
            <button
              className="group relative w-fit overflow-hidden rounded-md md:w-fit"
              onClick={() => {
                setSelectedIdx(idx);
                setIsOpen(true);
              }}
            >
              <img
                style={{
                  width,
                  height,
                  objectFit: 'cover',
                  position: 'relative',
                }}
                width={width}
                height="auto"
                src={item?.media?.mediumFullUrl}
                alt="image thubnail"
              />
              <div className="absolute bottom-0 left-0 right-0 top-0 z-10 flex items-center justify-center bg-black bg-opacity-50 opacity-0 transition-opacity group-hover:opacity-100">
                <FocusIcon color="#fff" />
              </div>
            </button>
          </li>
        ))}
      </ul>
      {typeof selectedIndex === 'number' && isOpen && (
        <Dialog
          open={isOpen}
          onOpenChange={open => {
            if (!open) {
              setSelectedIdx(null);
            }
            setIsOpen(prev => !prev);
          }}
        >
          <DialogOverlay />
          <DialogContent className="w-fit md:w-fit">
            <DialogHeader className="w-fit">
              <DialogTitle>이미지 자세히보기</DialogTitle>
            </DialogHeader>
            <div className="max-h-[90vh] overflow-auto">
              {images?.length > 1 ? (
                <Swiper
                  modules={[Pagination]}
                  spaceBetween={12}
                  slidesPerView={1}
                  pagination={{
                    clickable: true,
                  }}
                  style={{
                    width: '100%',
                    maxWidth: `${previewWidth}px`,
                  }}
                  initialSlide={selectedIndex}
                >
                  {images.map((item, idx) => (
                    <SwiperSlide
                      key={idx.toString()}
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        textAlign: 'center',
                      }}
                      className="mb-auto mt-auto"
                    >
                      <img
                        className="rounded-md object-cover"
                        width="100%"
                        height="auto"
                        src={item?.media?.bufferFullUrl}
                        alt="image preview"
                        style={
                          isPreviewRatioFixed
                            ? { aspectRatio: `${width}/${height}` }
                            : { objectFit: 'contain' }
                        }
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              ) : (
                <div
                  style={{
                    width: `${previewWidth}px`,
                    maxWidth: '100%',
                  }}
                >
                  {images.map((item, idx) => (
                    <div
                      key={idx.toString()}
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        textAlign: 'center',
                      }}
                      className="mb-auto mt-auto"
                    >
                      <img
                        className="rounded-md object-cover"
                        width="100%"
                        height="auto"
                        src={item?.media?.bufferFullUrl}
                        alt="image preview"
                        style={
                          isPreviewRatioFixed
                            ? { aspectRatio: `${width}/${height}` }
                            : { objectFit: 'contain' }
                        }
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
